// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CashierOutside_style_wrapper__29fxz","title":"CashierOutside_style_title__2CWNQ","goBack":"CashierOutside_style_goBack__3Nnpp"};